export const SALESFORCE_ERROR_ALERT = {
  title: 'Salesforce Error',
  msg:
    'Failed to retrieve Member Information from SalesForce. ' +
    'Please complete the booking by entering the ' +
    'information manually, or try refreshing the page.',
};
